import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ReportSend from './pages/home/ReportSend';
import ReportQuestion from './pages/AdminPanel/UserDoubt';
import ReportQuestionDetails from './pages/home/ReportQuestionDetails';

import Login from './pages/Auth/Login';
import SignUp from './pages/Auth/SignUp';
import Logout from './pages/Auth/Logout';
import Profile from './pages/Auth/Profile';
import UpdateProfile from './pages/Auth/UpdateProfile';
import AccountDelete from './pages/Auth/AccountDelete';
import AccountDeletionInstructions from './pages/Auth/AccountDeletionInstructions';
import AdminHome from './pages/AdminPanel/AdminHome';
import AllUsersBeforeLogin from './pages/AdminPanel/AllUsersBeforeLogin';
import AllUsers from './pages/AdminPanel/AllUsers';
import AppInstallUsers from './pages/AdminPanel/AppInstallUsers';
import AppItemsUse from './pages/AdminPanel/AppItemsUse';
import PaymentItems from './pages/AdminPanel/PaymentItems';
import AllPayments from './pages/AdminPanel/AllPayments';
import Navbar from './pages/home/Navbar';
import StudentMessage from './pages/AdminPanel/StudentMessage';




const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {

  return (

    <>

      <Navbar />

      <Routes>
        <Route path="/report-send/:id" element={<ReportSend />} />
        <Route path="/report-question" element={<ReportQuestion />} />
        <Route path="/report-question-details/:id/:displayId/:message" element={<ReportQuestionDetails />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/update-profile" element={<UpdateProfile />} />
        <Route path="/account-delete" element={<AccountDelete />} />
        <Route path="/account-deletion" element={<AccountDeletionInstructions />} />



        {/* Bckend side page  */}
        <Route path='' element={<AdminHome />} />
        <Route path="/all-users-data" element={<AllUsers />} />
        <Route path="/all-users-before-login" element={<AllUsersBeforeLogin />} />
        <Route path="/app-install-users" element={<AppInstallUsers />} />
        <Route path="/app-items-use" element={<AppItemsUse />} />
        <Route path="/all-payment-items" element={<PaymentItems />} />
        <Route path="/all-payments" element={<AllPayments />} />
        <Route path="/student-messages" element={<StudentMessage />} />


      </Routes>


    </>

  );
};

export default App;